<template>
  <div class="page-index">
    <div class="nav pc-img" :class="sticky ? 'sticky' : ''">
      <div class="header flex flex-cross-center">
        <div class="v2power_logo">
          <img class="logo_img" src="../assets/img/v2power_logo.svg" alt="" />
        </div>
        <div class="nav_list">
          <span
            class="nav_name"
            :class="{ active: item.id == selectedNav }"
            v-for="item in navList"
            :key="item.id"
            @click="selectNav(item)"
          >
            <a :href="'#' + item.id">{{ item.name }}</a></span
          >
        </div>
        <div class="contact_us">
          <a href="#contact">Contact us</a>
        </div>
      </div>
    </div>
    <div
      class="v2power_logo mobile-img flex flex-cross-center flex-main-center"
    >
      <img class="logo_img" src="../assets/img/v2power_logo.svg" alt="" />
    </div>
    <div id="home">
      <div class="home_body">
        <div class="home_content">
          <div class="home_content_left">
            <div class="content_title">
              <h5>Powering the Electric Future Together</h5>
              <h5>Crafting Your Fast-Charging Virtual Power Plant</h5>
            </div>
            <div class="content_info">
              Boost your earnings with the high- tech fast charging and storage
              system
            </div>
            <!-- <a
              href="https://v2power.io/simulator/index"
              class="go-charging-simulation"
              target="_blank"
              >Charging simulation</a
            > -->
          </div>
        </div>
      </div>
    </div>
    <div id="NEWS" class="news-side side-public-style">
      <h5>News</h5>
      <div class="news-side-content">
        <img src="../assets/img/NEWS.png" alt="" />
        <div>
          <h5>
            “V2Power and SpaceTimeAI at UCL Excel in Crafting Bespoke EV
            Charging Models”
          </h5>
          <p>
            V2Power and SpaceTimeAI at UCL boast their capacity to craft bespoke
            EV charging models that cater to client-specific datasets and needs.
            This includes considering unique regional charging behaviours,
            demographic nuances, income levels, and the constraints of local
            electrical grids, as well as the influences of weather and public
            holidays. The goal……
          </p>
          <a class="view-detail" href="pdf/introduce.pdf" target="_blank"
            >View detail</a
          >
        </div>
      </div>
    </div>
    <div id="About" class="about-side side-public-style">
      <h5>About us</h5>
      <div class="about-side-content">
        <p>
          Welcome to v2power, the forefront innovators in the green energy
          movement. Specializing in cutting-edge EV charging and advanced solar
          energy solutions, our mission is to revolutionize energy distribution.
          We are dedicated to empowering you with the means to dramatically
          reduce energy expenses and to build a robust, super-fast charging
          infrastructure.
        </p>
        <p class="tip">
          Our commitment is straightforward and unwavering: We are here to guide
          and support you in the transitiontowards sustainable energy, helping
          you to establish an efficient and cost-effective super charging
          networkJoin us in paving the way for a greener, more sustainable
          future.
        </p>
      </div>
    </div>
    <div id="Products" class="product-side side-public-style">
      <h5>Our products</h5>
      <div class="product-side-content">
        <p class="tip">
          At v2power, we offer a comprehensive suite of products that seamlessly
          blend software and hardware to revolutionize the energy landscape. Our
          offerings include:
        </p>
        <div class="offerings">
          <div>
            <img src="../assets/img/pc/Software.png" alt="" />
            <h6>Innovative Software Solutions:</h6>
            <p>
              Our software suite encompasses an Energy Management System (EMS)
              and a Charge Point Operator (CPO) platform. These tools work in
              tandem to optimize energy usage, enhance EV charging efficiency,
              and provide comprehensive monitoring and management capabilities.
            </p>
          </div>
          <div>
            <img src="../assets/img/pc/Hardware.png" alt="" />
            <h6>State-of-the-Art Hardware:</h6>
            <p>
              Our hardware range extends from high-performance charging stations
              to advanced energy storage systems and solar photovoltaic (PV)
              technology. Each component is engineered for maximum durability
              and reliability, ensuring a seamless integration into your energy
              infrastructure.
            </p>
          </div>
        </div>
        <img
          src="../assets/img/pc/station.png"
          class="station-img pc-img"
          alt=""
        />
        <img
          src="../assets/img/mobile/station.png"
          class="station-img mobile-img"
          alt=""
        />
        <div class="summary">
          <img
            class="mobile-img"
            src="../assets/img/mobile/Key functions.png"
            alt=""
          />
          <div class="summary-text">
            Together, our products form an intelligent ecosystem. They not only
            facilitate rapid electric vehicle charging and efficient energy
            storage but also harness the power of solar energy. Our integrated
            approach ensures the harmonious operation of a smart microgrid
            system, aligning with the power grid, renewable sources, and storage
            solutions. By prioritizing solar energy utilization, we are
            committed to advancing the effective application of clean energy,
            laying the foundation for a sustainable and green future.
          </div>
          <img class="pc-img" src="../assets/img/pc/Key functions.png" alt="" />
        </div>
        <div class="headwares">
          <h5>Hardwares</h5>
          <div class="headwares-content">
            <img src="../assets/img/pc/Charging.png" alt="" />
            <div>
              <p class="introduce">
                Our design features a detached system architecture, separating
                the charging guns from the power systems, which are housed in
                distinct cabinets. This separation optimizes space usage and
                enhances system efficiency. Each charging gun has a power
                capacity of 250kW, contributing to a total system capacity of
                480kW and significantly reducing charging times. Furthermore, we
                have focused on creating a versatile and user-friendly interface
                that accommodates various user preferences.
              </p>
              <div class="list">
                <p>·Slim charging pile</p>
                <p>·Ultra-fast charging</p>
                <p>·Plug and play</p>
                <p>·Customisable appearance and user interface</p>
              </div>
            </div>
          </div>
        </div>
        <div class="softwares">
          <h5>Softwares</h5>
          <div class="software-one ems">
            <img src="../assets/img/pc/EMS.png" alt="" />
            <div>
              <p class="title">EMS(“Energy Management System”)</p>
              <p>
                Our intelligent energy management system optimizes the use of EV
                chargers and local energy assets, such as renewable energy
                resources, battery storage, and loads. By utilizing smart
                charging techniques, it minimizes energy expenses and helps
                prevent the need for expensive infrastructure upgrades.
              </p>
            </div>
          </div>
          <div class="software-one cpo">
            <img class="mobile-img" src="../assets/img/mobile/CPO.png" alt="" />
            <div>
              <p class="title">CPO(“Charge Point Operator”)Platform</p>
              <p>
                Our CPO platform offers a wide range of functionalities for EV
                charging operations. It streamlines customer management, offers
                a flexible pricing model, includes a user-friendly mobile app,
                and features AI-driven business analytics dashboards for
                powerful insights.
              </p>
            </div>
            <img class="pc-img" src="../assets/img/pc/CPO.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div id="Partnership" class="partnerships-side side-public-style">
      <h5>Partnerships</h5>
      <p class="introduce">
        In partnership with local experts, our team is ready to assist you in
        procuring the right equipment and developing cost-effective virtual
        power plants, propelling us towards a net-zero society.
      </p>
      <div class="list">
        <div class="developer">
          <p class="title">Developer</p>
          <p>
            We can provide high-quality storage,PV and chargings solutions
            forproject developers, along with theassociated software platform.
          </p>
        </div>
        <div class="landowner">
          <p class="title">Landowner</p>
          <p>
            We can offer landowners businessplan as well as the
            comprehensivestorage,PV and chargings solutionsalong with subsequent
            assetmanagement and operationalservices software.
          </p>
        </div>
        <div class="installer">
          <p class="title">Installer</p>
          <p>
            We can supply installers with a largequantity of high-quality
            storage, PVand charging solutions.
          </p>
        </div>
      </div>
    </div>
    <div id="Cases" class="cases-side side-public-style">
      <h5>Case studies</h5>
      <div class="case-list">
        <div class="case-one car-park">
          <img class="pc-img" src="../assets/img/pc/Car park.png" alt="" />
          <img class="mobile-img" src="../assets/img/pc/Car park.png" alt="" />
          <p class="title">Car park (Under operation)</p>
          <p class="tip">Solar+Battery+Charging+Load</p>
          <p class="content">
            This is an integrated photovoltaic and energy storage charging
            station, featuring photovoltaic systems, energy storage systems, and
            a 480kW supercharging station. Moreover, the park is equipped with
            real-time monitoring screens for charging stations, facilitating
            orderly charging and improving energy utilization efficiency.
          </p>
        </div>
        <div>
          <div class="case-one charging-station flex">
            <img
              class="pc-img"
              src="../assets/img/pc/charging station.png"
              alt=""
            />
            <img
              class="mobile-img"
              src="../assets/img/mobile/charging station.png"
              alt=""
            />
            <div>
              <p class="title">
                EV stores super charging station (Under operation)
              </p>
              <p class="content">
                We have created 12 charging stations in 8 regions for automobile
                4S stores, increasing services, attracting customers, and
                generating revenue through brand collaborations and personalized
                design.
              </p>
            </div>
          </div>
          <div class="case-one industrial-park flex">
            <img
              class="pc-img"
              src="../assets/img/pc/Industrial park.png"
              alt=""
            />
            <img
              class="mobile-img"
              src="../assets/img/mobile/Industrial park.png"
              alt=""
            />
            <div>
              <p class="title">Industrial park (Under operation)</p>
              <p class="tip">Solar+Battery+Charging+Load</p>
              <p class="content">
                We extensively utilize PV in the industrial park to meet the
                power needs of the charging stations and loads within the park.
                By harnessing solar energy and generating electricity, we can
                effectively reduce electricity costs and decrease reliance on
                the grid.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="case-one brownfield-project">
        <img
          class="pc-img"
          src="../assets/img/pc/Brownfield project.png"
          alt=""
        />
        <img
          class="mobile-img"
          src="../assets/img/mobile/Brownfield project.png"
          alt=""
        />
        <div>
          <p class="title">Brownfield project (Design completed)</p>
          <p class="tip">Solar+Battery+Charging+Load</p>
          <p class="content">
            This is a 160,000 square meter site that integrates solar power
            generation, energy storage, charging stations, and local loads. We
            have designed renewable technologies to create the first innovative
            solar storage and flexible service area demonstration project on the
            island. Additionally, we will provide hardware equipment and a
            comprehensive energy management system, offering comprehensive
            technical support in the field of new energy.
          </p>
        </div>
      </div>
    </div>
    <div id="contact">
      <div class="about">
        <div class="all_margin contact_body">
          <div class="contact_word">
            <div class="word_top">
              If you're interested in starting a project or obtaining a quote
              for one of our services, please send an email to info@v2power.io.
              One of our exceptional team members will promptly contact you to
              discuss your requirements.
            </div>
            <div class="word_margin word_top">
              Alternatively, you can fill out the form below and include as much
              information as possible in the message. This will ensure that your
              query is directed to the appropriate expert.
            </div>
          </div>
          <div class="send_msg">
            <div class="msg_title">Contact information</div>
            <!-- <el-input
              clearable
              class="input_info"
              v-model="contactInfo.name"
              placeholder="You name"
            ></el-input>
            <el-input
              clearable
              class="input_info"
              v-model="contactInfo.email"
              placeholder="You email"
            ></el-input>
            <el-input
              clearable
              maxlength="11"
              class="input_info"
              v-model="contactInfo.phone"
              placeholder="You phone"
              @input="handleEdit"
            ></el-input>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              class="input_info"
              v-model="contactInfo.message"
              placeholder="You message"
            ></el-input> -->
            <el-form :model="contactInfo" ref="contactInfo">
              <el-form-item
                prop="name"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Name cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  clearable
                  class="input_info"
                  :maxlength="50"
                  v-model="contactInfo.name"
                  placeholder="Your name"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Email address cannot be empty',
                    trigger: 'blur'
                  },
                  {
                    type: 'email',
                    message: 'Please enter the correct email address',
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input
                  :maxlength="50"
                  clearable
                  class="input_info"
                  v-model="contactInfo.email"
                  placeholder="Your email"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="phone"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Mobile phone number cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  clearable
                  :maxlength="20"
                  class="input_info"
                  v-model="contactInfo.phone"
                  @input="handleInput"
                  placeholder="Your phone"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="message"
                label=""
                :rules="[
                  {
                    required: true,
                    message: 'Information cannot be empty',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  type="textarea"
                  :maxlength="256"
                  :autosize="{ minRows: 2, maxRows: 3 }"
                  class="input_info"
                  v-model="contactInfo.message"
                  placeholder="Your message"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div class="msg_btn" @click="submitForm('contactInfo')">
                  Send message
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="btnFlag" class="backTop" @click="backTop">
      <img src="../assets/img/backtop.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sticky: false,
      btnFlag: false,
      isMobile: false,
      selectedNav: "About",
      navList: [
        { id: "About", name: "About us" },
        { id: "Products", name: "Our products" },
        { id: "Partnership", name: "Partnership" },
        { id: "NEWS", name: "News" },
        { id: "Cases", name: "Case studies" }
      ],
      contactInfo: {
        name: "",
        email: "",
        phone: "",
        massage: ""
      }
    };
  },
  methods: {
    selectNav(item) {
      this.selectedNav = item.id;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // alert("submit!");
          const qs = require("qs");
          let info = {
            name: this.contactInfo.name,
            email: this.contactInfo.email,
            phone: this.contactInfo.phone,
            message: this.contactInfo.message
          };
          // let info = new FormData();
          // info.append("name", this.contactInfo.name);
          // info.append("email", this.contactInfo.email);
          // info.append("phone", this.contactInfo.phone);
          // info.append("message", this.contactInfo.message);
          this.$http
            .post("/PHPMailer/sendMail.php", qs.stringify(info), {
              "content-type": "application/x-www-form-urlencoded;charset=UTF-8;"
              // "content-type": "application/json;charset=UTF-8;"
            })
            .then(res => {
              console.log(res, "res");
              this.$message({
                message: "Thank you for your message",
                type: "success"
              });
              this.contactInfo.name = "";
              this.contactInfo.email = "";
              this.contactInfo.phone = "";
              this.contactInfo.message = "";
            })
            .catch(res => {
              console.log(res, "error submit!!");
              this.$message.error("Sorry, upload failed");
            });
        } else {
          return false;
        }
      });
    },
    handleInput(value) {
      // 只允许输入"+"、"-"、正整数和0
      let reg = /^[+-]?\d+$/;
      if (!reg.test(value)) {
        this.$nextTick(() => {
          this.contactInfo.phone = value.replace(/[^-+\d]/g, "");
        });
      }
    },
    sendMsg() {
      console.log(this.contactInfo.name, "name");
      console.log(this.contactInfo.email, "email");
      console.log(this.contactInfo.phone, "phone");
      console.log(this.contactInfo.massage, "massage");
    },
    backTop() {
      const that = this;
      const timer = setInterval(() => {
        const isPeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + isPeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(that.scrollToTop, "scroll");
      that.scrollTop = scrollTop;
      that.sticky = that.scrollTop > 0;
      if (that.scrollTop > 300) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    // 在组件挂载后获取屏幕宽度并进行判断
    this.isMobile = window.innerWidth < 800;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 800;
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>

<style lang="scss">
$primary-color: #00A5DF;
.el-textarea__inner {
  resize: none;
}
p,
h4,
h5,
h6,
span,
a,
input,
.el-textarea__inner {
  font-family: Verdana, Verdana;
}
@media screen and (min-width: 912px) {
  .box_margin {
    margin-top: 1rem;
  }
  .all_margin {
    margin: 0 10%;
  }
  .backTop {
    width: 0.6rem;
    position: fixed;
    bottom: 0.8rem;
    right: 5%;
    cursor: pointer;
  }
  .about {
    margin: 1rem auto;
    width: 100%;
    max-width: 1920px;
  }
  .margin_left {
    margin-left: 10%;
  }
  .margin_right {
    margin-left: 0.6rem;
    margin-right: 10%;
  }
  .other_margin {
    margin-right: 0.6rem;
  }
  .word_content {
    color: rgba(51, 51, 51, 1);
    line-height: 0.35rem;
    text-align: justify;
  }
  .logo_img {
    width: 2rem;
  }
  .page-index {
    font-size: 0.18rem;
    .pc-img {
      display: block;
    }
    .mobile-img {
      display: none;
    }
    p {
      line-height: 0.3rem;
    }
    .nav {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
      height: 0.8rem;
      &.sticky {
        background-color: rgba(0, 0, 0, 0.4);
      }
      .header {
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .v2power_logo {
          margin-top: 0.08rem;
        }
        .nav_list {
          padding-top: 0.06rem;
          .nav_name {
            position: relative;
            margin: 0 0.3rem;
            a {
              color: #fff;
            }
            &.active {
              font-weight: bold;
              &::after {
                position: absolute;
                content: "";
                width: 100%;
                height: 0.04rem;
                background: $primary-color;
                bottom: -0.14rem;
                left: 0;
              }
            }
          }
        }
        .contact_us {
          flex-shrink: 0;
          width: 1.2rem;
          height: 0.4rem;
          border-radius: 0.4rem;
          background: $primary-color;
          text-align: center;
          line-height: 0.4rem;
          font-size: 0.16rem;
          a {
            color: #fff;
          }
        }
      }
    }
    #home {
      background-color: rgba(0, 133, 80, 0.06);
      width: 100%;
      .home_body {
        max-width: 1920px;
        margin: 0 auto;
        height: 9rem;
        background-image: url("../assets/img/pc/bg.png");
        background-size: 100% 100%;
        .home_content {
          padding-top: 2.7rem;
          margin-left: 10%;
          display: flex;
          justify-content: space-between;
          position: relative;
          .home_content_left {
            // width: 47%;
            .content_title {
              font-size: 0.48rem;
              color: #fff;
              font-weight: 600;
              line-height: 0.67rem;
              font-family: PingFangSC-Semibold, PingFang SC;
            }
            .content_info {
              margin-top: 0.5rem;
              font-size: 0.18rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
              line-height: 0.28rem;
              text-align: justify;
            }
            .go-charging-simulation {
              display: inline-block;
              width: 4.2rem;
              height: 0.68rem;
              line-height: 0.68rem;
              background: $primary-color;
              box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
              border-radius: 20px;
              text-align: center;
              color: #fff;
              font-size: 0.24rem;
              margin-top: 1rem;
            }
          }
          .home_content_right {
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: 46vw;
          }
        }
      }
    }
    .side-public-style {
      padding: 0 2rem;
      margin-top: 0.4rem;
      h5 {
        font-size: 0.48rem;
        color: $primary-color;
        font-family: Verdana, Verdana;
        margin-bottom: 0.4rem;
        font-weight: bold;
        padding-top: 0.8rem;
      }
    }
    .news-side {
      .news-side-content {
        background: #f6f9fc;
        padding: 0.4rem;
        display: flex;
        img {
          margin-right: 0.4rem;
        }
        h5 {
          font-weight: bold;
          font-size: 0.28rem;
          color: #333333;
          line-height: 0.4rem;
          margin-bottom: 0.4rem;
        }
        .view-detail {
          display: inline-block;
          width: 1.2rem;
          height: 0.4rem;
          border-radius: 0.4rem;
          background: $primary-color;
          text-align: center;
          line-height: 0.4rem;
          font-size: 0.16rem;
          color: #fff;
          cursor: pointer;
          margin-top: 0.4rem;
        }
      }
    }
    .about-side {
      p {
        color: #333333;
        font-size: 0.24rem;
        font-family: Verdana;
        line-height: 0.36rem;
        &.tip {
          font-weight: bold;
          margin-top: 0.4rem;
        }
      }
    }
    .product-side {
      .product-side-content {
        .tip {
          margin-bottom: 0.2rem;
        }
        .offerings {
          display: flex;
          div {
            padding: 0.8rem 0.4rem;
            background-color: rgba(24, 90, 169, 0.04);
            &:first-child {
              margin-right: 0.2rem;
            }
            img {
              margin-bottom: 0.4rem;
              width: 1rem;
            }
            h6 {
              margin-bottom: 0.2rem;
              color: $primary-color;
              font-size: 0.24rem;
            }
            p {
              line-height: 0.3rem;
            }
          }
        }
        .station-img {
          margin: 0.2rem 0;
        }
        .summary {
          display: flex;
          .summary-text {
            background-color: rgba(24, 90, 169, 0.04);
            margin-right: 0.2rem;
            line-height: 0.36rem;
            color: #333333;
            font-size: 0.24rem;
            padding: 0.2rem;
          }
          img {
            width: 10rem;
          }
        }
        .headwares {
          width: calc(100vw - 6px);
          height: 9rem;
          background: $primary-color;
          margin-left: -2rem;
          margin-top: 1.2rem;
          padding: 0.2rem 2rem;
          color: #fff;
          .headwares-content {
            display: flex;
            img {
              height: 7rem;
            }
          }
          h5 {
            margin-bottom: 0.4rem;
            color: #fff;
            padding-top: 0;
          }
          .introduce {
            padding-top: 0.2rem;
            margin-left: 0.2rem;
            font-size: 0.24rem;
            line-height: 0.4rem;
          }
          .list {
            display: flex;
            flex-wrap: wrap;
            margin-top: 1rem;
            margin-left: 0.2rem;
            p {
              width: 50%;
              font-weight: bold;
              line-height: 0.6rem;
            }
          }
        }
        .softwares {
          h5 {
            color: $primary-color;
            margin-top: 1.2rem;
            margin-bottom: 0.6rem;
            font-weight: bold;
          }
          .title {
            font-weight: bold;
            margin-bottom: 0.3rem;
          }
          p {
            font-size: 0.24rem;
            line-height: 0.36rem;
          }
          .ems {
            margin-bottom: 1rem;
            display: flex;
            img {
              margin-right: 0.6rem;
              width: 7rem;
            }
          }
          .cpo {
            display: flex;
            img {
              margin-left: 0.6rem;
              width: 7rem;
            }
          }
        }
      }
    }
    .partnerships-side {
      .introduce {
        margin-bottom: 0.4rem;
      }
      .list {
        color: #fff;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 0.2rem;
        }
        .title {
          font-weight: bold;
          font-size: 0.24rem;
          margin-top: 5rem;
          margin-bottom: 0.4rem;
        }
        & > div {
          width: 32%;
          height: 8rem;
          padding: 0 0.2rem;
        }
        .developer {
          background-image: url("../assets/img/pc/Developer.png");
          background-size: 100% 100%;
        }
        .landowner {
          background-image: url("../assets/img/pc/Landowner.png");
          background-size: 100% 100%;
        }
        .installer {
          background-image: url("../assets/img/pc/Installer.png");
          background-size: 100% 100%;
        }
      }
    }
    .cases-side {
      .case-list {
        display: flex;
      }
      .case-one {
        background: rgba(24, 90, 169, 0.04);
        border-radius: 8px;
        .title {
          font-weight: bold;
        }
      }
      .car-park {
        width: 5rem;
        flex-shrink: 0;
        margin-right: 2%;
        padding: 0.2rem;
        .title {
          margin-top: 0.5rem;
          margin-bottom: 0.2rem;
        }
        .tip {
          margin-bottom: 0.4rem;
        }
      }
      .charging-station,
      .industrial-park {
        padding: 0.2rem;
        img {
          margin-right: 0.4rem;
          width: 4.5rem;
        }
      }
      .charging-station {
        .title {
          margin: 0.4rem 0;
        }
      }
      .industrial-park {
        margin-top: 0.2rem;
        .title {
          margin-top: 0.4rem;
        }
        .tip {
          margin-top: 0.1rem;
          margin-bottom: 0.4rem;
        }
      }
      .brownfield-project {
        margin-top: 0.2rem;
        padding: 0.2rem;
        display: flex;
        img {
          margin-right: 0.4rem;
        }
        .title {
          margin-top: 0.4rem;
        }
        .tip {
          margin-top: 0.1rem;
          margin-bottom: 0.4rem;
        }
      }
    }
    #contact {
      margin-top: 2rem;
      background-color: rgba(8, 4, 4, 1);
      color: #ffffff;
      padding: 1rem 0;
      .contact_body {
        position: relative;
        .contact_word {
          width: 50%;
          .word_top {
            font-size: 0.2rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.28rem;
            text-align: justify;
          }
          .word_margin {
            margin-top: 1rem;
          }
        }
        .el-form-item {
          margin-bottom: 0.22rem;
        }
        .send_msg {
          background: #ffffff;
          border-radius: 0.28rem;
          line-height: 0.4rem;
          width: 6.5rem;
          padding: 0.4rem 0.6rem;
          box-shadow: 0 8px 8px rgba(10, 16, 20, 0.24),
            0 0 0.08rem rgba(10, 16, 20, 0.12);
          position: absolute;
          top: -2.7rem;
          right: 0px;
          .msg_title {
            color: #333333;
            font-weight: 600;
            margin-bottom: 0.3rem;
          }
          .msg_btn {
            background: #080404;
            line-height: 0.6rem;
            border-radius: 0.08rem;
            color: #ffffff;
            text-align: center;
            margin: 0.3rem 0px 0px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 912px) {
  @import "./media.scss";
}
</style>
